import type { FC } from 'react';
import { useHits } from 'react-instantsearch-core';
import { FormattedMessage } from 'react-intl';

import { Col } from '@/components/Col';
import { Flex } from '@/components/Flex';
import { Grid } from '@/components/Grid';
import { Typography } from '@/components/Typography';
import { useIsSmDown } from '@/hooks/useMedia';
import type { StoreHit } from '@/integrations/algolia/types';
import * as FM from '@/messages/forms';

import type { OpeningHours } from '../../DeliveryView/components/BoutiquePickup';
import { openingHours } from '../../DeliveryView/components/BoutiquePickup';

export const BoutiqueOpeningHours: FC = () => {
  const { hits } = useHits<StoreHit>();
  const hours = hits[0] && (hits[0].hours as OpeningHours);
  const isMobileView = useIsSmDown();

  return (
    <Grid
      data-test-id='BoutiqueOpeningHoursGrid'
      gridAutoFlow={isMobileView ? 'row' : 'column'}
      gridTemplateColumns={isMobileView ? '1fr' : '1fr 1fr'}
      gridTemplateRows='repeat(4,22px)'
    >
      {hours &&
        openingHours.map((item) => (
          <Col
            key={item}
            data-test-id={`BoutiqueOpeningHoursColumn-${item}`}
            xs={1}
          >
            <Flex>
              <Typography mr={2} width={80}>
                <FormattedMessage {...FM.formMessages[item]} /> ：
              </Typography>
              <Typography>
                {hours?.[item]?.openIntervals?.[0]?.start} -{' '}
                {hours?.[item]?.openIntervals?.[0]?.end}
              </Typography>
            </Flex>
          </Col>
        ))}
    </Grid>
  );
};

export default BoutiqueOpeningHours;
